module.exports = __webpack_public_path__ + "media/images/gallery/constellations/corvus/crv_figure-bd0ed9ccdd76187c556f363b673aecb4.gif";